<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-08-18 23:33 -->
<!-- Description:  -->
<template>
  <div>
    <h4>Reporte de Liquidaciones de Charisma</h4>
    <div class="row mb-3">
      <div class="col-md-3">
        <label>Tipo de filtro</label>
        <select class="form-control" v-model="filtroTipo" :disabled="loading">
          <option value="anioMes">Año y mes</option>
          <option value="rango">Rango de fechas</option>
        </select>
      </div>
      <template v-if="filtroTipo === 'anioMes'">
        <div class="col-md-2">
          <label>Año</label>
          <input
            class="form-control"
            type="number"
            v-model.number="date.year"
            :disabled="loading"
          />
        </div>
        <div class="col-md-4">
          <label>Mes</label>
          <app-select-month
            v-model.number="date.month"
            :disabled="loading"
          ></app-select-month>
        </div>
      </template>
      <template v-else>
        <div class="col-md-3">
          <label>Fecha inicial</label>
          <input
            class="form-control"
            type="date"
            v-model="range.date_init"
            :disabled="loading"
          />
        </div>
        <div class="col-md-3">
          <label>Fecha final</label>
          <input
            class="form-control"
            type="date"
            v-model="range.date_end"
            :disabled="loading"
          />
        </div>
      </template>
      <div class="col-md-2 d-flex align-items-end">
        <button
          class="btn btn-primary"
          :disabled="loading"
          @click="consultar()"
        >
          <i class="fa fa-search"></i>
          <span>Consultar</span>
        </button>
      </div>
    </div>
    <iframe
      ref="elIframe"
      class="w-100"
      style="height: 1080px; border: 1px solid #dee2e6"
      frameborder="0"
      :src="link"
    ></iframe>
  </div>
</template>
<script>
import { myMoment } from "src/utils/myMoment.js";
import ReportServices from "./ReportServices.js";
export default {
  name: "ReportCharisma01",
  components: {
    //
  },

  // directives

  props: {
    //
  },

  data: () => ({
    filtroTipo: "anioMes",
    date: {
      year: myMoment().year(),
      month: myMoment().month() + 1
    },
    range: {
      date_init: myMoment().startOf("month").format("YYYY-MM-DD"),
      date_end: myMoment().endOf("month").format("YYYY-MM-DD")
    },
    loading: false,
    link: ""
  }),

  computed: {
    //
  },

  // watch: {},

  mounted() {
    //
  },

  methods: {
    consultar() {
      let range;
      if (this.filtroTipo === "anioMes") {
        if (!this.date.year || !this.date.month) {
          return;
        }
        let m = myMoment(`${this.date.year}-${this.date.month}-1`, "YYYY-M-D");
        range = {
          date_init: m.format("YYYY-MM-DD"),
          date_end: m.endOf("month").format("YYYY-MM-DD")
        };
      } else {
        if (!this.range.date_init || !this.range.date_end) {
          return;
        }
        range = {
          date_init: this.range.date_init,
          date_end: this.range.date_end
        };
      }
      this.loading = true;
      ReportServices.charismaReport01(range)
        .then((res) => {
          const blob = new Blob([res], { type: "text/html" });
          if (this.link) {
            URL.revokeObjectURL(this.link);
          }
          this.link = URL.createObjectURL(blob);
        })
        .catch(() => {
          const blob = new Blob(
            [`<div style="padding: 20px; font-family: Arial, sans-serif; color: #721c24;">Fallo la consulta del reporte.</div>`],
            { type: "text/html" }
          );
          if (this.link) {
            URL.revokeObjectURL(this.link);
          }
          this.link = URL.createObjectURL(blob);
        })
        .finally(() => {
          this.loading = false;
        });
    }
    //
    //
  }
};
</script>
<style scoped></style>
